<template>
  <div
    v-if="cols === 1"
    :class="classes"
  >
    <ColOne
      proportion="100"
      :width="props.width"
    >
      <template #one>
        <slot name="one" />
      </template>
    </ColOne>
  </div>
  <div
    v-if="cols === 2"
    :class="classes"
  >
    <ColTwo
      :proportion="proportion"
      :width="props.width"
    >
      <template #one>
        <slot name="one" />
      </template>
      <template #two>
        <slot name="two" />
      </template>
    </ColTwo>
  </div>
  <div
    v-if="cols === 3"
    :class="classes"
  >
    <ColThree
      proportion="33-33-33"
      :width="props.width"
    >
      <template #one>
        <slot name="one" />
      </template>
      <template #two>
        <slot name="two" />
      </template>
      <template #three>
        <slot name="three" />
      </template>
    </ColThree>
  </div>
</template>

<script setup lang="ts">
import ColOne from "./ColOne.vue";
import ColTwo from "./ColTwo.vue";
import ColThree from "./ColThree.vue";
import { computed } from "vue";

defineOptions({
  name: "MenuCols"
})

const autoClasses = [
  'sm:!max-w-[calc(640px-6rem)]',
  'lg:!max-w-[calc(1024px-6rem)]',
  'xl:!max-w-[calc(1280px-6rem)]',
  '2xl:!max-w-[calc(1536px-6rem)]',
];

const classes = computed(() => {
  return props.width === 'full' ? props.classes : autoClasses.concat(props.classes);
})

const props = defineProps({
  proportion: { type: String, default: '' },
  width: { type: String, default: 'full' },
  classes: { type: String, default: '' }
})

const cols = computed(() => {
  const split = props.proportion.split('-');
  return split.length
})
</script>
